export default [
  {
    "id": 47,
    "date": "2019-06-21T04:48:04",
    "date_gmt": "2019-06-21T04:48:04",
    "guid": {
      "rendered": "http:\/\/localhost:8000\/?p=47"
    },
    "modified": "2020-05-09T21:14:50",
    "modified_gmt": "2020-05-09T21:14:50",
    "slug": "game-on",
    "status": "publish",
    "type": "post",
    "link": "https:\/\/api.gamechange.nz\/game-on\/",
    "title": {
      "rendered": "Game On"
    },
    "content": {
      "rendered": "",
      "protected": false
    },
    "excerpt": {
      "rendered": "",
      "protected": false
    },
    "author": 1,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": [],
    "categories": [
      1
    ],
    "tags": [],
    "acf": {
      "article_components": [
        {
          "acf_fc_layout": "slide_group",
          "group_name": "humphrey",
          "slides": [
            {
              "type": "text",
              "text": [
                {
                  "paragraph": ""
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "initial"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "This is Humphrey Hanley. "
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "rotate"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "He was born with hands."
                },
                {
                  "paragraph": " He was born with fingernails."
                },
                {
                  "paragraph": " But it was quickly apparent that there was a problem."
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "hands"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "He was also born with a rare condition, which means his skin does not attach like most people's."
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "zoomIn"
            },
            {
              "type": "quote",
              "text": [
                {
                  "paragraph": "The condition, called Epidermolysis bullosa, means over the years when his hands would rub and blister, they would scar over. "
                }
              ],
              "quote": {
                "quote_id": "humphrey1"
              },
              "triggerAction": "sway1"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "The condition, called epidermolysis bullosa, means over the years when his hands would rub and blister, they would scar over. "
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "zoomOut"
            },
            {
              "type": "quote",
              "text": [
                {
                  "paragraph": "Now, save for a thumb, he has no fingers. Online he goes by the name \u201cNo Hands, No Excuses\u201d "
                }
              ],
              "quote": {
                "quote_id": "humphrey2"
              },
              "triggerAction": "sway2"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "Now, save for a thumb, he has no fingers. Online he goes by the name \u201cNo Hands, No Excuses\u201d. "
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "humphreyDissolve"
            }
          ],
          "controller_slide": ""
        },
        {
          "acf_fc_layout": "article",
          "article_blocks": [
            {
              "acf_fc_layout": "text_block",
              "text_block": "<p>It happened so slowly that he didn\u2019t notice. Ten years ago Humphrey could hold a pool cue. Now, he has adapted every part of his life to his reality.<\/p>\n",
              "blockClass": "intro"
            },
            {
              "acf_fc_layout": "image_block",
              "image_group": "middle"
            },
            {
              "acf_fc_layout": "text_block",
              "text_block": "<p>He goes to the same coffee shop every day so he doesn\u2019t need to keep telling them that he needs his coffee lukewarm, or he won&#8217;t be able to pick it up. He has cable ties on all his cameras to allow him to easily zoom his lenses in and out. He has a friend who 3D prints him accessories which allow him to use his computer more comfortably. He wears double tennis wristbands, over where he hands should be, to give him some extra padding.<\/p>\n<p>\u201cIt\u2019s one of the joys of growing up Kiwi, we all learn how to adapt,\u201d Humphrey says.<\/p>\n<p>But one of the more difficult parts of growing up Kiwi was dealing with other people. Because any sort of friction could cause him damage, even walking around the playground with other children was almost impossible.<\/p>\n<p>He had some friends his own age but, more often than not, he preferred to stay away from those situations.<\/p>\n<p>Starting from when he was very young, Humphrey also remembers video games being an escape. In the 1980s, he first played his grandfather&#8217;s computer. Then a local Lions club fundraised to get him an Amiga 500 &#8211; one of the first successful home computers.<\/p>\n<p>Having such a machine meant that there was something that Humphrey could do on his own. Then, when the internet came along, it allowed him to be part of communities and not be judged on his handshake, \u201cor lack thereof\u201d.<\/p>\n<p>\u201cIt\u2019s almost impossible to quantify how important it was to find a place like that. We are all searching for a place we can belong.\u201d<\/p>\n<p>Playing video games was the first time that he felt like he was picked for a team.<\/p>\n",
              "blockClass": ""
            },
            {
              "acf_fc_layout": "image_block",
              "image_group": "end"
            },
            {
              "acf_fc_layout": "text_block",
              "text_block": "<p>Humphrey had been seeing this community grow around him &#8211; people with disabilities who were playing games. All of them were trying to make do with the equipment that was available. There wasn&#8217;t much that was made with them in mind. That demographic of gamers had always been on the periphery to the huge mass market. Then something strange happened.<\/p>\n",
              "blockClass": "community"
            },
            {
              "acf_fc_layout": "text_block",
              "text_block": "<p>At the SuperBowl last year, which offers up the most expensive advertising space in the world, Microsoft launched a 1 minute promotion. But, instead of it highlighting a new game title on its Xbox, they let the world know about its new \u201cadaptive controller\u201d.<\/p>\n<p>It featured case studies of children who were all now able to play video games a little easier than before thanks to this piece of hardware. The controller gave players the ability to augment it, depending on the needs of its user.<\/p>\n<p>The tagline was: \u201cWhen everybody plays, we all win.\u201d<\/p>\n<p>Cher tweeted about it. The rapper, T-Pain, tweeted about it.<\/p>\n<p>\u201cPeople you never hear talk about video games, you never hear them talk about disability &#8211; having both was incredible,\u201d says Humphrey.<\/p>\n",
              "blockClass": ""
            }
          ]
        },
        {
          "acf_fc_layout": "slide_group",
          "group_name": "controller",
          "slides": [
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "The controller looks simple enough. "
                },
                {
                  "paragraph": "But it allows different equipment to be attached to it. "
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "controllerIntro"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "It could be a foot pedal, which is how Humphrey uses it."
                },
                {
                  "paragraph": "Or a joystick you can operate with your mouth. "
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "controllerRotateStart"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "Or even just larger buttons."
                },
                {
                  "paragraph": "With another function it can allow another gamer to help control players on screen. "
                },
                {
                  "paragraph": " So if a person has very limited mobility - perhaps they can do the running while a friend does the jumping."
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "controllerRotateFinish"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "The whole gaming industry has evolved with the assumption that the people who are playing have the full function of all their limbs. "
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "controllerToHumphrey"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "But Humphrey says that has missed a key group of people - ones who by no choice of their own are often limited by their conditions. "
                },
                {
                  "paragraph": "And Humphrey says, hopefully, they are teaching game developers and production studios that they matter."
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "sway1"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "\"I think there are a lot of stereotypes around what your typical gamer is and that is someone that stays at home and just sits on the couch all day playing video games. But what's often overlooked, when you think about that stereotype, is people with disabilities aren't there by choice. We are stuck at home often anyway because our disabilities limits our ability to interact with the real world. But video games provide us that virtual world and real community to then get out there and interact with.\""
                }
              ],
              "quote": {
                "quote_id": "humphrey4"
              },
              "triggerAction": "sway1"
            },
            {
              "type": "quote",
              "text": [
                {
                  "paragraph": "I think there alot of sterotype around what your typical gamer is and that is ya-know someone that stays at home and just sits on the couch all day playing video games but whats often overlooked when you think about that sterotype is people with disabilities arent there by choice ya-know we are stuck at home often anyway because our disabilities limits our ability to interact with the real world but video games provides us that virtual world and real community to then get out there and interact with."
                }
              ],
              "quote": {
                "quote_id": "humphrey4"
              },
              "triggerAction": "intial"
            },
            {
              "type": "text",
              "text": [
                {
                  "paragraph": "He says gaming creates a way for people to be a part of the real world be part of real communities and have real friendships."
                },
                {
                  "paragraph": "\u201cBy having a virtual world is like being set free.\u201d"
                }
              ],
              "quote": {
                "quote_id": []
              },
              "triggerAction": "superHeroHands"
            }
          ],
          "controller_slide": ""
        }
      ]
    },
    "_links": {
      "self": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts\/47"
        }
      ],
      "collection": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts"
        }
      ],
      "about": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/types\/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/users\/1"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/comments?post=47"
        }
      ],
      "version-history": [
        {
          "count": 53,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts\/47\/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 275,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts\/47\/revisions\/275"
        }
      ],
      "wp:attachment": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/media?parent=47"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/categories?post=47"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/tags?post=47"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https:\/\/api.w.org\/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 45,
    "date": "2019-06-21T04:45:37",
    "date_gmt": "2019-06-21T04:45:37",
    "guid": {
      "rendered": "http:\/\/localhost:8000\/?p=45"
    },
    "modified": "2020-05-19T00:03:59",
    "modified_gmt": "2020-05-19T00:03:59",
    "slug": "game-face",
    "status": "publish",
    "type": "post",
    "link": "https:\/\/api.gamechange.nz\/game-face\/",
    "title": {
      "rendered": "Game Face"
    },
    "content": {
      "rendered": "",
      "protected": false
    },
    "excerpt": {
      "rendered": "",
      "protected": false
    },
    "author": 1,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": [],
    "categories": [
      1
    ],
    "tags": [],
    "acf": {
      "article_components": [
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><strong>The porridge has been plugged with banana and sprinkled with cinnamon. The shoes are firmly on. The 10-minute walk through suburban Napier is complete and, for the next several hours, one-year-old Leon is safely in preschool. So, with five hours to spare, his mother, Lorien Gugich, 26, starts her walk back home. Her head is down, she stares at her phone, scrolling through her social media feeds. The transformation has begun.<\/strong><\/p>\n",
          "blockClass": "intro"
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "intro"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p>Gugich is a slight young woman with recently-dyed brilliant yellow hair. She wears a pink baseball cap, a nose ring and a tattoo on her arm bearing the name \u201cPop Squad\u201d in colorful ink. She enters her studio, pulls out the mascara and lipstick and stares intensely into a mirror. Slowly, surely, Lorien, a single mum in provincial Aotearoa, becomes \u201cLoriiPops \u201d &#8211; one of New Zealand\u2019s most successful video game streamers.<\/p>\n",
          "blockClass": "description"
        },
        {
          "acf_fc_layout": "video",
          "videoID": "lorien"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p>Today, that time is at 10am, sharp. She needs to be punctual because people are on standby. Sitting in her Twitch channel chatroom are dozens of viewers from all around the world, anxiously waiting for Lorrii to start playing a video game while narrating her experience. For the privilege, they pay a subscription &#8211; starting at $4.99 a month going up to $24.99. And, while not everyone pays, there are now more than 92,000 people that follow her channel.<\/p>\n",
          "blockClass": "morning routine"
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "followers"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p>Twitch began in 2007 as a website allowing gamers to livestream their play to the world. Since then, it has gathered 2.2 million people who all broadcast parts of their lives. Almost 20,000 of them are \u2018partners\u2019, meaning they can make money off their streams by attracting subscriptions or running advertisements. Lorien is such a partner. The site is now owned by internet behemoth Amazon, which is trying to capitalize on an ever-growing number of enthusiasts. Some estimates suggest there are more than 2.5 billion video gamers all over the world.<\/p>\n",
          "blockClass": "twitch"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p>Not surprisingly, Lorien raises some eyebrows when she tells people, particularly those of an older generation, that she plays video games for a living.<\/p>\n<blockquote><p>\u201cI describe it like a magazine subscription, you pay however much, then they bring out more magazines, more content.\u201d<\/p><\/blockquote>\n<p>For that older generation, the first question she asks is whether they know what YouTube is. If they do, she says: \u201cIt\u2019s like YouTube, but it\u2019s all live.\u201d<\/p>\n<p>It\u2019s all live and it\u2019s all big business. The highest paid streamer in the world says he earns several hundred thousand dollars a month.<\/p>\n<p>It\u2019s been a journey for Lorien, who was first introduced to video games by her dad. He would sit her on his knee, while she watched in awe as he slew baddies on the way to eventual victory.<\/p>\n<p>\u201cVideo games were sort of quite exciting back then,\u201d she says. \u201cIt was otherworldly. My love for them just grew from there.\u201d<\/p>\n<p>When Lorien was going through a difficult time in her life she stumbled upon a video game streamer on YouTube. The footage was pre-recorded but she found his narration, and his demeanor, fun and welcoming. She could watch him play like she was in the room too.<\/p>\n<p>At its core, watching him play, made her feel better. She wanted to do that too.<\/p>\n<p>\u201cI thought \u2018hey I want to do this and make people laugh\u2019.\u201d<\/p>\n<p>When she started, she was quite shy. She would pre-record her play and would not have a camera showing her face. Lorien hated the idea of people actually seeing her while she played. Then she came out of her shell. She bought a video camera and showed herself to the internet world.<\/p>\n<p>\u201cThen I just grew from there.\u201d<\/p>\n<p>She opens the door to her gaming room, which is decked out with miscellaneous memorabilia and fan art made by her subscribers. She settles into her computer chair, which resembles a racing seat, and scans the three screens in front of her. One screen shows the game she is playing, the other shows her own face and the activity of her followers, who are constantly typing her questions. The final screen is for managing the whole operation.<\/p>\n",
          "blockClass": "gaming"
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "playing"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p>The clock ticks over to 10am. It is time.<\/p>\n<p>\u201cHey Pop Squad!\u201d she says, in not quite a shout. \u201cSo great to see you.\u201d<\/p>\n<p>As new users sign on and make themselves known, she will call out their names and repeat it back to them with the same suffix: \u201cYou ruuuullllle.\u201d<\/p>\n<p>Lorien plays games on their hardest levels. Which today is making for a rather masochistic experience as she struggles with a game that sees her try to jump and climb from block to block while facing blizzards that continually blow her into the abyss below.<\/p>\n<p>She screams and fake cries and \u201crages\u201d at the screen, but she is always in control, always portraying a charming character that converses with people as they jump in with advice or idle chit chat.<\/p>\n<p>But her \u201ccommunity\u201d as she calls it, is not there just for her. They are also there for each other.<\/p>\n<p>\u201cI love them to death,\u201d Lorien says. \u201cI have got a really good core community of people that support me, no matter what happens in my life or their life. We are a bunch of warm loving people.\u201d<\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "community"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p>Together they have raised funds for charities, as well as for Lorien herself when her marriage broke up two years ago and she was forced to return to New Zealand from the United States, where she was living. The community helped her, her son and then her cat \u201cPixel\u201d come home.<\/p>\n<p>\u201cIt\u2019s just amazing the power of community when people look up to you and care about you \u2026 It\u2019s a very unique thing that not many people understand.\u201d<\/p>\n<p>Lorien says they all come to her channel because she sets a positive tone. She is energetic, she is smiling and welcoming.<\/p>\n<p>\u201cPeople are drawn to positivity.\u201d<\/p>\n<p>But she is still keen to share the less happy parts of her life.<\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "video",
          "videoID": "feelings"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p>The line of work is sometimes to blame for that. Streaming is a competitive business. That guy who makes several hundred thousand dollars a month is named, Tyler Blevins, better known as \u201cNinja\u201d. He has 14.6 million followers on Twitch. But he is an outlier. The majority of streamers must get by with niche audiences, whom they constantly feel responsible for.<\/p>\n<p>Lorien says if you are online every day then you are going to see a lot of success. Your following will grow.<\/p>\n<p>\u201cBut it&#8217;s not quite realistic and can be quite harmful to your mental health. Then if something happens and you can\u2019t Twitch, then you dive into this \u2018I\u2019m losing viewers and subscribers\u2019.\u201d<\/p>\n<p>That brings pressure. Your self-worth and financial wellbeing becomes wrapped up in that follower number. So Lorien makes sure she has a schedule and tries to have boundaries &#8211; eight hours a day broken up between the mornings when Leon is at school and the evening when he is asleep.<\/p>\n<p>That balance between a professional video gamer and being a mum can be tough, she says. But she tries to bring him on her journey as much as she can. He has been on work trips with her, while she travels to game conferences around the world.<\/p>\n<p>\u201cI can&#8217;t wait to see how he incorporates more into my life.\u201d<\/p>\n<p>She can see how quickly Leon has taken to an iPad, navigating through what he wants by swiping and pressing the screen with a seeming built-in intuition. So, Lorien is also keen to educate about video games too &#8211; not just benefits, but also their dangers.<\/p>\n<p>\u201cI think it&#8217;s really important that I raise him to not be addicted to video games,\u201d she says. \u201cThat&#8217;s all on me.\u201d<\/p>\n",
          "blockClass": "workshop"
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "portrait"
        },
        {
          "acf_fc_layout": "video",
          "videoID": ""
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "",
          "blockClass": "gamerKid"
        }
      ]
    },
    "_links": {
      "self": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts\/45"
        }
      ],
      "collection": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts"
        }
      ],
      "about": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/types\/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/users\/1"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/comments?post=45"
        }
      ],
      "version-history": [
        {
          "count": 50,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts\/45\/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 285,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts\/45\/revisions\/285"
        }
      ],
      "wp:attachment": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/media?parent=45"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/categories?post=45"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/tags?post=45"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https:\/\/api.w.org\/{rel}",
          "templated": true
        }
      ]
    }
  },
  {
    "id": 41,
    "date": "2019-06-21T04:41:49",
    "date_gmt": "2019-06-21T04:41:49",
    "guid": {
      "rendered": "http:\/\/localhost:8000\/?p=41"
    },
    "modified": "2020-06-11T00:56:52",
    "modified_gmt": "2020-06-11T00:56:52",
    "slug": "game-plan",
    "status": "publish",
    "type": "post",
    "link": "https:\/\/api.gamechange.nz\/game-plan\/",
    "title": {
      "rendered": "Game Plan"
    },
    "content": {
      "rendered": "",
      "protected": false
    },
    "excerpt": {
      "rendered": "",
      "protected": false
    },
    "author": 1,
    "featured_media": 0,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": [],
    "categories": [
      1
    ],
    "tags": [],
    "acf": {
      "article_components": [
        {
          "acf_fc_layout": "section_heading",
          "heading": "The Company"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">On the second floor of Avalon Studios, down a thin, grey hallway and through a sliding door with the name \u201cA44\u201d emblazoned on frosted glass, a dozen young men are sitting around a large flat-screen television trying their best to kill each other.\u00a0<\/span><\/p>\n",
          "blockClass": "intro"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">The game creators are playing games. Standing over all of it, in this large concrete stack of a building in Lower Hutt, is Michael Vermeulen &#8211; A44\u2019s lead game designer.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">At 15-years-old, Vermeulen wanted to be a soccer referee in his native Belgium. Even then, he loved setting the rules of engagement. <\/span><\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "intro"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">After refereeing 250 matches, and going through some of the top development programs in the country, Vermeulen saw his future unveil before him. He was to be a professional, in charge of dictating the rules to Europe\u2019s top players.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">Then, while he was officiating a match, his foot slipped into a hole in the pitch. Then, he felt his leg twist. He heard the snap. Vermeulen knew something was wrong when he looked down and saw that his leg was wobbly from the knee down. His ligament was torn and his future career was apparently over. <\/span><span style=\"font-weight: 400;\">But Vermeulen had always played games as a child. He had always created them too &#8211; board games and card games. He would even play the very early incarnations of video games but then pull them apart and reprogram them to see what they could do.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">There was something about games that fascinated him &#8211; the way you could build worlds for players and then give them choices, or the illusion of them. The goal was always to give those players a satisfying journey. Vermeulen wanted to set the rules once again &#8211; this time in the digital realm.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">So he studied game design, or the way in which games are created. He learned about the concepts and mechanics that hold them all together. From there, he started applying for jobs and landed one working for Ubisoft Blue Byte in Germany &#8211; one of the biggest game companies in the world.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">\u00a0<\/span><\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "video",
          "videoID": "mikeOne"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p>There are different elements of game design. For example, one person might be responsible for what a level in a game looks like. Another might figure out how two characters fight each other if it&#8217;s that sort of game. Another will figure out how the player navigates through the world that has been created. Then, on top of all of this, is what the game will actually look like.<\/p>\n",
          "blockClass": "intro"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">As sole combat designer at Ubisoft, Mike could have continued on a lucrative path working on some of the world\u2019s biggest games as a small cog in a huge machine. He would have been in command of how characters fight each other &#8211; the way they move, and the way they inflict harm.<\/span><\/p>\n<p>Instead, he chose to take a major gamble on the other side of the world at a studio which was years away from releasing its first project. His gamble was playing a bigger part in creating a smaller game. He knew that he wanted to control the whole process &#8211; from start to end. He wanted to be the games master.<\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "ashen"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">He soon got a call from Derek Bradley, who started Aurora 44 <\/span><span style=\"font-weight: 400;\">in a Featherston garage in 2013. He and his creative director, Leighton Milne, had been artists at Weta Workshop, where they worked on creating fantastical landscapes such as those in <\/span><i><span style=\"font-weight: 400;\">The Hobbit.<\/span><\/i><\/p>\n<p><span style=\"font-weight: 400;\">Their new venture was about creating one of the most ambitious games ever seen in New Zealand. By the time Vermeulen came aboard, they had already been working for two and a half years on the project.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">The concept was called <\/span><i><span style=\"font-weight: 400;\">Ashen <\/span><\/i><span style=\"font-weight: 400;\">&#8211; an open-world game which allowed players to explore their path as they saw fit. Rather than creating landscapes for a film, where the director controls the point of view, how much you can see or what you see, here the game creators wanted to give the user agency over their experience. Because of this, open-world games are complex, expensive and require intense design to make sure that the world and the player&#8217;s role within it make sense. You need to preempt where players might want to explore and what they might want to do. That takes time.\u00a0<\/span><\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "video",
          "videoID": "mikeTwo"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">Three months into Ashen\u2019s five-year development, Aurora 44 put out a since-deleted tweet about the game. It got picked up by some news outlets. Then Microsoft Xbox saw it. The team started talking with the company about what the game concept was. A year later they signed an exclusive game with them.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">This was a game-changer.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">Like all industries, the traditional retail model for gaming is changing. In previous years, studios were reliant on sales from brick-and-mortar outlets. Today\u2019s market is moving more towards digital download distribution, as well as subscription and streaming services.\u00a0<\/span><\/p>\n<p><span style=\"font-weight: 400;\">Ashen became tied to Xbox\u2019s Game Pass &#8211; a subscription service from Microsoft for use with its Xbox One console. Described as &#8220;Netflix for video games&#8221;, it grants users access to a catalog of more than 100 games for as low as NZ$12.95 a month.<\/span><\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">Ashen puts players inside the body of a wanderer in search of a place to call home. The characters all have their faces missing, giving it an otherworldly sense. That design decision also helped keep production costs down as faces are complex to create.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">At its core, the game is about forging relationships. You explore mysterious dungeons, fight epic bosses and explore diverse regions filled with gorgeous vistas and mythical creatures &#8211; all inspired by New Zealand\u2019s landscapes. You must turn your home into a lively town by choosing who to trust.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">As the Xbox publicity says: \u201cIn this new era of light, you must protect the Ashen and destroy the hungering shadows once and for all.\u201d<\/span><\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">The link between Weta and A44 is not lost on local game developers. They describe the games industry as being where New Zealand\u2019s film industry was before the Lord of the Rings arrived in Wellington and catapulted this part of the world into becoming \u2018Middle Earth\u2019 &#8211; a title that the country still struggles to shrug off.<\/span><\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "section_heading",
          "heading": "The Landscape"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">Cassandra Gray, the chair of the New Zealand Game Developers Association (NZGDA), says there\u2019s no reason video games can\u2019t be the new film industry.\u00a0<\/span><\/p>\n",
          "blockClass": "intro"
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "cassandra"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">With 39% compound annual growth rate over the past six years, she says game development is New Zealand&#8217;s fastest-growing creative industry and one of the fastest-growing technology export sectors. The NZGDA says the country&#8217;s gaming companies brought in over $200 million 2019 &#8211; double the $99.9m earned only two years earlier in 2017. Almost all of that 96% of that revenue came from the export market.\u00a0\u00a0<\/span><\/p>\n<p>Then Covid-19 happened. Video game and console sales around the world lept during March 2020, when various lockdown measures were in place. Millions of people searched for social distancing-friendly activities to stay entertained during home quarantines.<\/p>\n<p>However, Gray felt the negative effect on the industry swiftly. She was made redundant from her work at Weta Gameshop <span style=\"font-weight: 400;\">&#8211; the company\u2019s recent move into the game market. When <\/span><span style=\"font-weight: 400;\">Weta looked to get into video games, it did not launch on traditional platforms, like the Xbox, it partnered with a much-hyped mixed reality headset, called the Magic Leap, which has recently announced its own ructions.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">The Florida-based company had raised US$2.3 billion for developing a wearable product that can superimpose digital creations into the real world. It sought to take gaming off the couch and into spaces you move around in &#8211; whether that be your lounge or a public park.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">Weta\u2019s founder Sir Richard Taylor sits on the board and employees from Magic Leap and Weta Gameshop shared office space, which is housed down a small alleyway on Weta\u2019s massive Miramar production lot. <\/span><\/p>\n<p><span style=\"font-weight: 400;\">But in April, there was a bombshell. The company&#8217;s founder, Ronnie Abovitz, announced it would be laying off half of its 2000-strong staff, including those working alongside Weta Gameshop. Abovitz said in a company blog post that it would shift away from trying to develop experiences for the consumer market. <\/span><\/p>\n<p><span style=\"font-weight: 400;\">The company was at one stage seen as the future of at-home immersive experiences. Instead, Magic Leap, Abovitz said, would dive headlong into trying to drive actual revenue via potential &#8220;enterprise&#8221; clients &#8211; which are likely large companies in the health-care, industrial and financial sectors. It leaves those creating entertainment experiences with Weta, out on in the cold.<\/span><\/p>\n<p>Gray said on Twitter after the announcement that she was &#8220;heartbroken&#8221; for her friends and former co-workers at Magic Leap in New Zealand.<\/p>\n<p>&#8220;We were creating truly special experiences down in our little corner of the world. I saw that at every event, in the face of every person experiencing mixed reality for the first time through one of our games.&#8221;<\/p>\n<p>&nbsp;<\/p>\n<p>&nbsp;<\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "gameshop"
        },
        {
          "acf_fc_layout": "video",
          "videoID": "mikeThree"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p>The Covid-19 pandemic might stymie the the NZGDA&#8217;s aspirations of creating a billion dollar industry in New Zealand by 2025. It meant the organisation had to cancel its popular conference this year.<\/p>\n<p>However, the hope is that might create impetus for the Government to step in and support an enterprise which could thrive in a locked down, closed borders situation.<\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "image_block",
          "image_group": "spaces"
        },
        {
          "acf_fc_layout": "video",
          "videoID": "mikeFour"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">While Prime Minister Jacinda Ardern did officially open the Weta Gameshop offices in 2018, Gray and the association are wanting the Government to do more than just ribbon cutting. They want support to allow game studios to offset some of the risks in creating new products.\u00a0<\/span><\/p>\n<p><span style=\"font-weight: 400;\">\u201cRight now we&#8217;ve got government economic plans for film, we&#8217;ve got them for music, so why couldn&#8217;t we have them for the for the games and interactive media industry?\u201d<\/span><\/p>\n<p><span style=\"font-weight: 400;\">The association is essentially advocating setting up another branch of funding. While the New Zealand Film Commission funds films and NZ on Air fund television, music and online content, there is nothing to support games.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">\u201cWe\u2019ve got a film commission, we\u2019ve got a music commission \u2013 why not an interactive one?\u201d<\/span><\/p>\n<p><span style=\"font-weight: 400;\">Because that\u2019s what Finland did. The Scandinavian nation is often held up as the benchmark for how governments can support the games industry. In the 1990s, game development in Finland did not really exist.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">Then,\u00a0 between 1995 and 2017, the government invested \u20ac75m into building it up. Its industry grew to over \u20ac2.36bn in revenue by 2017 &#8211; taking 7% of worldwide mobile game takings. All this in a country with a similar population to New Zealand.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">If you have ever heard of Angry Birds, you will know how far a little external help can go. Finland now boasts more than 200 game studios.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">\u201cIt\u2019s not just startups &#8211; although they do invest in startups,\u201d says Gray. \u201cThey invest in established companies that are looking to expand and that has led to them having such a massive and fantastic industry.\u201d<\/span><\/p>\n<p><span style=\"font-weight: 400;\">That is the goal, but first, they need to convince the minister in charge of video games of its merits. The only issue is that until Vanishing Point Studio started requesting interviews, the Government wasn\u2019t clear who that was. <\/span><\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "section_heading",
          "heading": "The Government\u2019s plan"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><strong>Phil Twyford admits he isn\u2019t a gamer. But now, sitting in his Beehive office holding a copy of the <em>Interactive Aotearoa<\/em> report, the economic development minister is now the minister for gaming. He also acknowledges that much of the report was news to him.<\/strong><\/p>\n",
          "blockClass": "minister"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">He says the reason why it was hard to find the right ministry for the industry to fit in was symptomatic of other issues.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">\u201cWhat that says is the rapidly converging world of digital media doesn\u2019t mesh well with silos of Government, and that is a lesson for Government and we are grappling with that.&#8221;<\/span><\/p>\n<p><em>Interactive Aotearoa<\/em>, produced by the Game Developers Association, lays out a roadmap for helping boost the video game industry in New Zealand. Its thesis is that the gaming industry is worth $143 million and is one of the fastest growing parts of country&#8217;s digital economy. The report says that if the current growth rate in interactive media was supported and planned for, it would be worth $1bn by 2025. As such, it needs help.<\/p>\n<p>Among other things, the report recommends creating an interactive commission and establishing an interactive innovation fund. It says that by creating a coordinated plan that invests in emerging talent and allows interactive media to access existing screen industry programmes, it can create hundreds of hi-tech and creative industry jobs.<\/p>\n<p>Twyford says that the report fits into the Government&#8217;s focus on creating an Industry Transformation Plan (ITP) for the creative sector but <span style=\"font-weight: 400;\">was unwilling to put a timetable or define the process for dealing with the recommendations. But he said the report provided &#8220;raw material for us to look at as part of the new industry transformation plan for the creative industries&#8221;.<\/span><\/p>\n<p>But with Twyford putting his hand up, the Government seems clear on it &#8211; gaming is an economic development issue.<\/p>\n",
          "blockClass": ""
        },
        {
          "acf_fc_layout": "video",
          "videoID": "phillTwyford"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><strong>Aurora 44, now known as A44, is on lockdown. <i>Ashen <\/i>has been completed to rave reviews. The hallways are lined with awards and, in true <i>Ashen-<\/i>style, a team photo with all the staff member\u2019s faces blurred out.<\/strong><\/p>\n",
          "blockClass": "outro"
        },
        {
          "acf_fc_layout": "text_block",
          "text_block": "<p><span style=\"font-weight: 400;\">Vermeulen says he\u2019s happy with the choice he made &#8211; coming to New Zealand from Belgium. He\u2019s happy with the work he did on <\/span><i><span style=\"font-weight: 400;\">Ashen<\/span><\/i><span style=\"font-weight: 400;\">.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">\u201cIt\u2019s also made people realise that \u2018hey, we\u2019re here, making games from New Zealand of all places and we don\u2019t make small games, we\u2019re trying to compete to be the best in the world\u2019.\u201d<\/span><\/p>\n<p><span style=\"font-weight: 400;\">To really compete, though, he says the Government needs to take the report seriously. If it doesn\u2019t, Vermeulen says there could easily be a plateau with studios leaving New Zealand or key talent leaving those studios.<\/span><\/p>\n<p><span style=\"font-weight: 400;\">In the meantime, A44 is going alone. They have released Ashen on other platforms now, allowing gamers of all stripes to see its vision. But despite the impact of Covid-19, the studio is still busy working on a new project. They won\u2019t say anything about it except that it is going to be self-funded. That means more risk, but also, more reward.<\/span><\/p>\n",
          "blockClass": ""
        }
      ]
    },
    "_links": {
      "self": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts\/41"
        }
      ],
      "collection": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts"
        }
      ],
      "about": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/types\/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/users\/1"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/comments?post=41"
        }
      ],
      "version-history": [
        {
          "count": 71,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts\/41\/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 289,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/posts\/41\/revisions\/289"
        }
      ],
      "wp:attachment": [
        {
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/media?parent=41"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/categories?post=41"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https:\/\/api.gamechange.nz\/wp-json\/wp\/v2\/tags?post=41"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https:\/\/api.w.org\/{rel}",
          "templated": true
        }
      ]
    }
  }
]